import { d as l } from "./chunk-debounce-Bk6yKvzA.js";
const { Shopify: i } = window;
document.addEventListener("DOMContentLoaded", () => {
  a(), o(), r();
});
const o = () => {
  document.addEventListener("click", (n) => {
    const e = n.target;
    e && e.tagName === "A" && i.analytics.publish("link_click", {
      link_classes: e.className,
      link_domain: e.href ? new URL(e.href).hostname : "",
      link_id: e.id,
      link_url: e.href,
      outbound: e.target === "_blank"
    });
  });
}, s = [10, 25, 50, 75], c = () => {
  const n = document.body.scrollHeight - window.innerHeight;
  if (n <= 0) return;
  const e = Math.round(window.scrollY / n * 100);
  for (const t of s)
    e >= t && i.analytics.publish("scroll_depth", {
      percent_scrolled: t
    });
}, d = l(c.bind(void 0), 100), a = () => {
  window.addEventListener("scroll", d);
}, r = () => {
  document.addEventListener("visibilitychange", () => {
    document.visibilityState === "hidden" ? i.analytics.publish("inactive", {}) : document.visibilityState === "visible" && i.analytics.publish("active", {});
  });
};
